import React, { createContext, useState, useEffect, useContext } from 'react';

const SettingsContext = createContext();

export const useSettings = () => useContext(SettingsContext);

export const SettingsProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => localStorage.getItem('app_theme') || '');
  const [mode, setMode] = useState(() => localStorage.getItem('app_mode') || 'light');
  const [apiProvider, setApiProvider] = useState(() => localStorage.getItem('app_api_provider') || 'zai');
  const [model, setModel] = useState(() => localStorage.getItem('app_ai_model') || 'glm-4.7-flash');
  const [zaiApiKey, setZaiApiKey] = useState(() => localStorage.getItem('app_zai_api_key') || '');
  const [openRouterApiKey, setOpenRouterApiKey] = useState(() => localStorage.getItem('app_openrouter_api_key') || '');

  useEffect(() => {
    localStorage.setItem('app_theme', theme);
    localStorage.setItem('app_mode', mode);
    document.documentElement.className = '';
    if (theme) document.documentElement.classList.add(theme);
    if (mode === 'dark') document.documentElement.classList.add('dark');
  }, [theme, mode]);

  useEffect(() => {
    localStorage.setItem('app_api_provider', apiProvider);
    localStorage.setItem('app_ai_model', model);
    localStorage.setItem('app_zai_api_key', zaiApiKey);
    localStorage.setItem('app_openrouter_api_key', openRouterApiKey);
  }, [apiProvider, model, zaiApiKey, openRouterApiKey]);

  return (
    <SettingsContext.Provider value={{
      theme, setTheme,
      mode, setMode,
      apiProvider, setApiProvider,
      model, setModel,
      zaiApiKey, setZaiApiKey,
      openRouterApiKey, setOpenRouterApiKey
    }}>
      {children}
    </SettingsContext.Provider>
  );
};